import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import EnterCode from "./pages/EnterCode";
import CreateAccount from "./pages/CreateAccount";
import Dashboard from "./pages/Dashboard";
import CreateEventPage from "./pages/CreateEventPage";
import SingleEvent from "./pages/SingleEvent";
import ModifyDetails from "./pages/ModifyDetails";
import RequestSong from "./pages/RequestSong";
import ProtectedRoutes from "./components/ProtectedRoute";
import EventSettings from "./pages/EventSettings";
import ActiveEvent from "./pages/ActiveEvent";
import AdminCreateAccount from "./pages/AdminCreateAccount";

import './styles/Global.css'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/aaal-vvou-b8b7-86fv-slpl-buil/admin/CreateAccount" element={<AdminCreateAccount />} />
        <Route path="/" element={<Home />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/EnterCode" element={<EnterCode />} />
        <Route path="/CreateAccount" element={<CreateAccount />} />
        <Route path="/dashboard" element={
          <ProtectedRoutes>
            <Dashboard />
          </ProtectedRoutes>
        } />
        <Route path="/CreateEvent" element={<CreateEventPage />} />
        <Route path="/Events/:eventId" element={<SingleEvent />} />
        <Route path="/ActiveEvent/:userId" element={<ActiveEvent />} />
        <Route path="/Events/:eventId/EventSettings" element={
          <ProtectedRoutes>
            <EventSettings />
          </ProtectedRoutes>
        } />
        <Route path="/ModifyDetails" element={
          <ProtectedRoutes>
            <ModifyDetails />
          </ProtectedRoutes>
        } />
        <Route path="/Events/:eventId/RequestSong" element={<RequestSong />} />
      </Routes>
    </Router>
  );
}

export default App;
